import InternalStaticAnchorChallengeList from 'models/application/anchor/types/internalStatic/types/ChallengeList';

export default class InternalStaticAnchorChallengeListService {
	toModel(anchor) {
		return new InternalStaticAnchorChallengeList(anchor);
	}
}
